<div class="message-body message-out message-text-long">
  <div class="message-content">
    <div class="d-flex">

      <div>
        <!--<h6 class="mb-2 font-weight-bold">{{message.sender.name || 'Рассылка'}}</h6>-->
        <div class="text-break text-white d-inline-block">
          <div>
            ID: <b>{{message.partner.id}}</b>
          </div>
          <div>
            Пополнений: <b>2 000 ₽. Получено 100 ₽ - 5% </b>
          </div>
          <div>
            Email: <b>{{message.partner.email}}</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
